export default __webpack_public_path__ + "static/media/contact.e93663e2.jpg";